<template>
  <section class="form-template address-data">
    <b-loading :active.sync="isLoading" :can-cancel="false" />
    <b-field
      :label="this.$t('endereco.buscarcep')"
      @click="buscarEndereco(cepbusca)"
    >
      <div class="columns">
        <b-input
          class="column is-9"
          type="search"
          v-model.lazy="cepbusca"
          v-mask="['#####-###']"
          :placeholder="commonPlaceholder"
          @keyup.native.enter="buscarEndereco(cepbusca)"
        />
        <button
          class=" column is-3 button-terciary is-info"
          @click="buscarEndereco(cepbusca)"
        >
          Buscar
        </button>
      </div>
    </b-field>
    <form @submit.prevent="atualizarDadosPaciente" class="form-template">
      <div class="columns">
        <div class="column">
          <b-field :label="this.$t('endereco.logradouro')">
            <b-input
              name="address"
              v-model.lazy="paciente.Logradouro"
              :placeholder="commonPlaceholder"
              @input="isReady()"
              required
            />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field :label="this.$t('endereco.numero')">
            <b-input
              name="addressNumber"
              v-model.lazy="paciente.Numero"
              :placeholder="commonPlaceholder"
              @input="isReady()"
              required
            />
          </b-field>
        </div>
        <div class="column">
          <b-field :label="this.$t('endereco.complemento')">
            <b-input
              v-model.lazy="paciente.Complemento"
              name="addressComplement"
              :placeholder="commonPlaceholder"
              @input="isReady()"
            />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field :label="this.$t('endereco.bairro')">
            <b-input
              name="neighborhood"
              v-model.lazy="paciente.Bairro"
              :placeholder="commonPlaceholder"
              @input="isReady()"
              required
            />
          </b-field>
        </div>
        <div class="column">
          <b-field :label="this.$t('endereco.cidade')">
            <b-input
              name="city"
              v-model.lazy="paciente.Cidade"
              :placeholder="commonPlaceholder"
              :disabled="desabilitado"
              @input="isReady()"
              required
            />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field :label="this.$t('endereco.estado')">
            <b-select
              v-model.lazy="paciente.Estado"
              :placeholder="dropdown"
              :disabled="desabilitado"
              @input="isReady()"
              required
            >
              <option v-for="option in estados" :key="option.sigla">
                {{ option.sigla }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <b-field :label="this.$t('endereco.cep')">
            <b-input
              v-model.lazy="paciente.Cep"
              v-mask="['#####-###']"
              :placeholder="commonPlaceholder"
              :disabled="desabilitado"
              required
            />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column is-4 is-offset-8">
          <div class="field">
            <button
              :disabled="!disabledButton"
              class="button button-primary"
              type="submit"
            >
              {{ $t('botoes.atualizar') }}
            </button>
          </div>
        </div>
      </div>
    </form>
    <modal-template v-if="showModal" class="override-modal">
      <template #header>
        <h2>{{ modalInfo.titulo }}</h2>
      </template>
      <template #body>
        <p>{{ modalInfo.subtitulo }}</p>
      </template>
      <template #footer>
        <button
          id="loginmodal"
          class="button button-primary"
          @click="modalInfo.acaoBotao"
        >
          {{ modalInfo.btnTexto }}
        </button>
      </template>
    </modal-template>
  </section>
</template>

<script>
import router from '@/router'
import ModalTemplate from '@/components/shared/modal/ModalTemplate'
import { mapGetters, mapActions } from 'vuex'
import CEPService from '@/services/cep-service.js'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'

export default {
  components: {
    ModalTemplate
  },
  data() {
    return {
      isLoading: false,
      commonPlaceholder: this.$t('placeholders.common'),
      dropdown: this.$t('placeholders.dropdown'),
      disabledButton: false,
      cepbusca: '',
      desabilitado: true,
      showModal: false
    }
  },

  props: {
    paciente: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters({
      estados: 'getUFS'
    })
  },

  methods: {
    ...mapActions(['atualizarEndereco']),
    atualizarDadosPaciente() {
      this.isLoading = true
      this.atualizarEndereco({
        CodigoPessoa: this.paciente.Codigo,
        CodigoCidade: this.paciente.CodigoCidade,
        Logradouro: this.paciente.Logradouro,
        Numero: this.paciente.Numero,
        Complemento: this.paciente.Complemento,
        Bairro: this.paciente.Bairro,
        Cep: this.paciente.Cep
      })
        .then(() => {
          this.desabilitado = true
          this.mostrarModal(
            this.$t('mensagens.sucesso'),
            this.$t('mensagens.dados-atualizados'),
            this.$t('botoes.confirmar'),
            this.toggleInfoModal
          )
        })
        .catch((err) => {
          if (err instanceof NotAuthenticatedError) {
            router.push('/')
          } else {
            this.desabilitado = false
            this.mostrarErro(err)
          }
        })
        .finally(() => {
          this.isLoading = false
          this.disabledButton = true
        })
    },
    isReady() {
      this.disabledButton = true
    },
    toggleInfoModal() {
      this.showModal = !this.showModal
    },
    mostrarModal(titulo, subtitulo, textoBotao, acaoBotao) {
      this.modalInfo = {
        titulo: titulo,
        subtitulo: subtitulo,
        btnTexto: textoBotao,
        acaoBotao: acaoBotao
      }
      this.showModal = !this.showModal
    },
    errorText(titulo, mensagem) {
      this.mostrarModal(
        titulo,
        mensagem,
        this.$t('botoes.confirmar'),
        this.toggleInfoModal
      )
    },
    mostrarErro(err) {
      var titulo = this.$t('erro.padrao.subtitulo')
      var mensagem = err.errors != null ? err.errors[0] : err.detail

      this.errorText(titulo, mensagem)
    },
    async buscarEndereco(cep) {
      this.isLoading = true
      await CEPService.buscarCEP(cep)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.json()
        })
        .then((data) => {
          this.isLoading = false
          if (data.CodigoCidade === 0) {
            this.disabledButton = false
            this.desabilitado = false
            this.commonPlaceholder = ''
          } else {
            this.disabledButton = true
            this.desabilitado = true
            this.commonPlaceholder = this.$t('placeholders.common')
          }

          Object.assign(this.paciente, data)
        })
        .catch(() => {
          this.isLoading = false
          this.paciente.Cep = cep
          this.disabledButton = true
          this.desabilitado = false
          this.commonPlaceholder = this.$t('placeholders.common')
          this.isLoading = false
          this.mostrarModal(
            this.$t('erro.padrao.titulo'),
            this.$t('erro.padrao.subtitulo'),
            this.$t('botoes.confirmar'),
            this.toggleInfoModal
          )
        })
    }
  },
  created() {
    this.$store.dispatch('setUFS')
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
.address-data {
  padding-right: 5.3125rem;
  padding-left: 5.3125rem;
}
@media (max-width: 64rem) {
  .address-data {
    padding-right: 0;
    padding-left: 0;
  }
}
</style>
